import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCallCancel: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCallCancel"><Path d="M4.00015 21.4144L21.4144 4.00015L20.0002 2.58594L10.837 11.7491C10.3468 11.1701 9.91044 10.544 9.5358 9.87866L11.1295 8.285L9.54403 3.00024H3V4.00024C3 8.33484 4.62228 12.2905 7.29279 15.2933L2.58594 20.0002L4.00015 21.4144Z" fill="currentColor"/><Path d="M20 21.0002C16.3893 21.0002 13.0415 19.8746 10.2884 17.955L13.9043 14.3391C13.9762 14.3816 14.0487 14.4234 14.1216 14.4644L15.7152 12.8708L21 14.4562V21.0002H20Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCallCancel;
